import {catchError, tap} from 'rxjs/operators';
import {SERVER_API_URL} from '../../app.config';
import {Injectable} from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpResponse, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {Messages, SnackbarService, SharedService} from '..';
import {BAD_CREDENTIALS} from '../constants/common.constants';
import {Router} from '@angular/router';


@Injectable()
export class AppInterceptor implements HttpInterceptor {

  constructor(
    private snackbarService: SnackbarService,
    private sharedService: SharedService,
    private router: Router
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req || !req.url || (/^https/.test(req.url) && !(SERVER_API_URL && req.url.startsWith(SERVER_API_URL)))) {
      return next.handle(req);
    }

    console.log("intercept to inject tokens...");

    // This is being used as a Pre-shared Key.  Once the API is ready, need to swap back to using the Auth0 token.
    const tempToken = "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhcGlfdXNlckBjb25uZWN0YXBvZ2VlLmNvbSIsImF1dGgiOiJST0xFX0FETUlOIiwiZXhwIjoxOTg3NjU0MzIxfQ.o3bYtUuWwwjnbAodKXfSUGPNFKT1iN7KTMp9V9MfOJEbMmqsfXvZE969N3HwPYOW9BsxNjVTKapY073hjTs9Eg";
    var authToken = this.sharedService.getAccessToken();

    console.log("authToken: " + authToken);
    if(authToken == null)
    {
      authToken = this.sharedService.getAccessToken();
    }

    var idToken = this.sharedService.getIdToken();

    console.log("idToken: " + idToken);

    let authRequest;
    if (authToken && idToken) {
      console.log("authToken + idToken")
      authRequest = req.clone({ headers: req.headers.set('Authorization', 'Bearer ' + authToken).append('IdToken', idToken).append('SecToken', tempToken) });
    }
    else if (authToken) {
      console.log("authToken")
      authRequest = req.clone({ headers: req.headers.set('Authorization', 'Bearer ' + authToken).append('SecToken', tempToken) });
    } 
    else {
      console.log("clone")
      authRequest = req.clone();
    }
    return next
      .handle(authRequest).pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
            this.requestSuccess(event);
          }
          return event;
        }, (error) => {
          return throwError(error);
        }),
        catchError((error: HttpErrorResponse) => {
          if (error.error.applicationErrorCode === 5000 && error.status === 401) {
            this.snackbarService.error(error.error.message);
            this.router.navigateByUrl('customer/dashboard');
          } else if (error.status === 401 || error.status === 403) {
            //this.sharedService.logout();  //DO NOT FORCE LOG OUT!  TODO: change this back once development is done.
            if (error.error.detail !== BAD_CREDENTIALS) {
              this.snackbarService.error(Messages.ErrorMsg.session_timeout);
            } else {
              this.snackbarService.error(error.error.title);
            }
          } else if (error.status === 404) {
            this.snackbarService.error(Messages.ErrorMsg.nodata);
          } else if (error.status === 500) {
            if (error.error.message) {
              this.snackbarService.error(error.error.message);
            }
          } else if (error.status === 502) {
            this.snackbarService.error(Messages.ErrorMsg.device_unreachable);
          } else if (error.status === 400) {
            if (error.error.applicationErrorCode) {
              this.snackbarService.error(error.error.message);
            } else {
              this.snackbarService.error(error.error.title);
            }
          }
          return throwError(error);
        })
      );
  }

  requestSuccess(res: HttpResponse<any>) {
    return res;
  }
}
